export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-sheriff-badge-283f919a718b7f167b3ac7a16783b6fa.svg";